import {NfcCard} from "@variocube/app-api";
import {classNames, layout, typography, View} from "@variocube/cube-ui";
import * as React from "react";
import {Fragment, useEffect, useState} from "react";
import {stylesheet} from "typestyle";
import {Controller} from "../controller/Controller";

interface NfcReaderViewProps {
    controller: Controller;
}

export function NfcReaderView({controller}: NfcReaderViewProps) {
    const [card, setCard] = useState<NfcCard|undefined>(undefined);

    useEffect(() => {
        controller.nfcReader.addCardListener(setCard);
        return () => controller.nfcReader.removeCardListener(setCard);
    }, [controller]);

    const keys = card?.uid
        ? { raw: atob(card.uid), base64: card.uid }
        : undefined;

    return (
        <View className={layout.paddingMedium}>
            <div>Current card UID:</div>
            <div className={styles.keys}>
                {keys && Object.entries(keys).map(([k, v]) => (
                    <Fragment>
                        <div>{k.toUpperCase()}</div>
                        <div className={classNames(typography.monospace, styles.card)}>
                            {v}
                        </div>
                    </Fragment>
                ))}
                {!keys && (
                    <div className={classNames(typography.monospace, styles.card)}>
                        No card present.
                    </div>
                )}
            </div>
        </View>
    )
}

const styles = stylesheet({
    card: {
        backgroundColor: "#f0f0f0",
        padding: "0.75em 1.5em",
        borderRadius: "0.25em",
        margin: "0.75em 0"
    },
    keys: {
        marginTop: '0.75rem'
    }
});

